const prMessages = {
  /* 01.General */
  'general.copyright': 'Sistema Nube © Todos os direitos reservados.',
  'general.choose-option': 'Escolher',
  'general.january': 'Janeiro',
  'general.february': 'Fevereiro',
  'general.march': 'Março',
  'general.april': 'Abril',
  'general.may': 'Maio',
  'general.june': 'Junho',
  'general.july': 'Julho',
  'general.august': 'Agosto',
  'general.september': 'Setembro',
  'general.october': 'Outubro',
  'general.november': 'Novembro',
  'general.december': 'Dezembro',
  'general.date': 'Data',
  'general.code': 'Código',
  'general.discount': 'Desconto',
  'general.discountType': 'Modelo',
  'general.couponType': 'Tipo de cupom',
  'general.since': 'Válido de',
  'general.until': 'Valido ate',
  'general.state': 'Estado',
  'general.amount': 'Resultar',
  'general.save': 'Salve',
  'general.points': 'Pontos',
  'general.datetime': 'Data e hora',
  'general.type': 'Modelo',
  'general.detail': 'Detalhe',
  'general.actions': 'Ações',
  'general.adhered': 'Aderido',
  'general.businesses': 'Negócios',
  'general.destinations': 'Destinos',
  'general.all': 'Tudo',
  'general.all-2': 'Tudo',
  'general.pay': 'Pague',
  'general.entities': 'Agências',
  'general.name': 'Nome',
  'general.number': 'Número',
  'general.expiration': 'Data de validade',

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  'user.forgot-password': 'Você esqueceu sua senha',
  'user.forgot-password-title': 'Recuperar minha senha',
  'user.forgot-password-text':
    '<b> Atenção! </b> Uma senha temporária será enviada para o e-mail com o qual você se cadastrou. Se você não se inscreveu, vá para a seção Registro.',
  'user.forgot-password-email': 'Complete seu email',
  'user.reset-password-button': 'Eu quero minha senha',
  'user.new-password-again': 'Nova senha novamente',
  'user.new-password': 'Nova Senha ',
  'user.new-password-label': 'Complete sua nova senha',

  'user.reset-password-title': 'Redefinir Senha',
  'user.reset-password-text': 'Escolha sua nova senha para fazer login com seu usuário',
  'user.reset-password': 'Redefinir senha',

  'user.login-title': 'Iniciar sessão',
  'user.login-password-text':
    'Preencha suas credenciais e comece a desfrutar de todos os benefícios',
  'user.login-button': 'Conecte-se',

  'user.register': 'Registro',
  'user.register-text': 'Preencha seus dados e comece a desfrutar de todos os benefícios',
  'user.fullname': 'Nome e sobrenome',
  'user.cellphone': 'Número de telemóvel',
  'user.birthday': 'Data de nascimento',
  'user.day': 'Dia',
  'user.month': 'Mês',
  'user.year': 'Ano',
  'user.document-type': 'Tipo de documento',
  'user.document': 'Número de identidade',
  'user.gender': 'Gênero',
  'user.accept': 'Eu aceito o',
  'user.terms': '<b>termos e condições</b>',
  'user.email': 'E-mail',
  'user.card': 'Número do cartão',
  'user.password': 'Senha',
  'user.forgot-password-question': 'Senha esquecida?',
  'user.logout': 'Sair',
  'user.login': 'Iniciar sessão',
  'user.register-button': 'Criar uma conta',
  'user.recommendationCode': 'Código para referir',
  'user.refererCodeSponsor': 'Código de recomendación',

  'user.tooltip-document': 'Apenas dígitos, sem espaços em branco ou sinais',
  'user.tooltip-disabled-document':
    'Se seus dados estiverem incorretos, você deve solicitar uma atualização manual em nosso site',
  'user.tooltip-password': 'A senha deve ter entre 6 e 11 caracteres alfanuméricos',
  'user.male': 'Masculino',
  'user.female': 'Feminino',
  'user.not-defined': 'Não especifica',

  'topnav.userLogged.my-account': 'Minha conta',
  'topnav.userLogged.my-card': 'Meu cartão',
  'topnav.userLogged.my-money': 'Meu dinheiro',
  'topnav.userLogged.my-discounts': 'Meus descontos',
  'topnav.userLogged.my-vouchers': 'Meus Vouchers',
  'topnav.userLogged.my-activity': 'Minha atividade',
  'topnav.userLogged.my-giftcards': 'Minha cartões de presente',
  'topnav.terms': 'Termos e Condições',
  'topnav.use-coupon': 'Use cupom',

  /* 03.Menú */
  'menu.home': 'Home',
  'menu.discounts': 'Descontos',
  'menu.awards': 'Prêmios',
  'menu.adheredBusinesses': 'Empresas',
  'menu.destinations': 'Destinos',

  /* 04.Home */
  'home.latest-awards': 'Últimos Prêmios',
  'home.latest-discounts': 'Últimos Descontos',
  'home.adhered-businesses': 'Empresas Afiliadas',
  'home.adhered-destinations': 'Destinos Aderidos',

  /* 05.Cards */
  'cards.user.welcome': 'Receber',
  'cards.user.points': 'Pontos',
  'cards.user.money': 'Dinheiro',
  'cards.user.gameCoins': 'Game Coins',

  /* 06.Benefits */
  'benefits.categories': 'Categorías',
  'benefits.adheredBusinesses': 'Empresas Afiliadas',
  'benefits.destinations': 'Destinos Aderidos',
  'benefits.discounts': 'Descontos',
  'benefits.awards': 'Prêmios',

  /* 07.Benefit Details */
  'benefit-details.details': 'Detalhes',
  'benefit-details.description': 'Descrição',
  'benefit-details.adheredBusiness': 'Empresa Afiliada',
  'benefit-details.destination': 'Destino Aderido',
  'benefit-details.category': 'Categoria',
  'benefit-details.without-category': 'Sem categoria',
  'benefit-details.stock': 'Estoque',
  'benefit-details.required-points': 'Pontos requeridos',
  'benefit-details.required-money': 'Dinheiro requerido',
  'benefit-details.points': 'Pontos',

  /* 08.Social Media */
  'social-media.whatsapp': 'Whatsapp',
  'social-media.facebook': 'Facebook',
  'social-media.button-facebook': 'Continue no Facebook',
  'social-media.google-map': 'Google Map',
  'social-media.instagram': 'Instagram',
  'social-media.website': 'Site Web',

  /* 09.Validations */
  'validations.required': 'É necessário',
  'validations.min': 'Deve ter pelo menos {min} caracteres',
  'validations.max': 'Deve ter no máximo {max} caracteres',
  'validations.email': 'Formato de email inválido',
  'validations.email-required': 'E-mail é obrigatório',
  'validations.password-required': 'Senha requerida',
  'validations.accept-terms': 'Você deve aceitar os Termos e Condições',
  'validations.accept-oneOf': 'Você deve escolher um desses valores: ',
  'validations.award-points': 'Você não tem pontos suficientes para obter este prêmio',
  'validations.award-money': 'Você não tem dinheiro suficiente para receber este prêmio',
  'validations.discount-points': 'Você não tem pontos suficientes para obter este desconto',
  'validations.discount-money': 'Você não tem dinheiro suficiente para obter este desconto',
  'validations.pay-money-required': 'Você deve preencher o valor para pagar',
  'validations.pay-money': 'Você não pode pagar uma quantia que você não tem',
  'validations.money-points': 'Você não tem pontos para mudar',
  'validations.money-slide': 'Você deve deslizar para resgatar seus pontos',
  'validations.money-selected-points': 'Você não tem os pontos selecionados para alterar',

  /* 10.Success Messages */
  'success-messages.password-sent': 'A senha foi enviada!',
  'success-messages.check-email': 'Verifique a conta de e-mail {email}',
  'success-messages.award-exchanged': 'Prêmio resgatado',
  'success-messages.coupon-saved': 'Desconto obtido',
  'success-messages.coupon-used': 'Cupom usado',
  'success-messages.voucher-saved': 'Voucher gerado',
  'success-messages.voucher-downloaded': 'Voucher baixado',
  'success-messages.money-loaded': 'Dinheiro Carregado',
  'success-messages.ok': 'Foi salvo com sucesso',

  /* 11.Error Pages */
  'error-pages.404-title': '404: Clube não encontrado',
  'error-pages.inactive-title': 'Site inativo',

  /* 12.Error Messages */
  'error-messages.nok': 'Ocorreu um erro',

  /* 13.Award Exchanges */
  'award-exchange.button': 'Intercâmbio',

  /* 14.Coupons */
  'coupons.button': 'Obtivermos',
  'coupons.valid-since': 'Cupom válido de',
  'coupons.valid-until': 'até',
  'coupons.code': 'Código do cupom',
  'coupons.show-in-commerce': 'Mostrar na caixa',
  'coupons.qr-text': 'Se o QR for escaneado, o cupom será usado. Estará definitivamente perdido.',
  'coupons.exchange-online': 'Resgate online',
  'coupons.code-copy':
    'Copie o código do cupom e cole-o para obter o desconto correspondente na compra.',
  'coupons.use': 'Usar',
  'coupons.use-later': 'Usar mais tarde',

  /* 15.Money */
  'money.exchange-points': 'Resgate pontos por dinheiro',
  'money.pay': 'Pague com meu dinheiro',
  'money.show-voucher': 'Mostrar voucher',

  /* 16.Activity */
  'activity.monthly-purchases': 'Compras Mensais',
  'activity.my-interactions': 'Últimas interações',

  /* 17.Profile */
  'profile.summary': 'Resumo',
  'profile.personal-data': 'Dados pessoais',
  'profile.account-data': 'Dados da conta',
  'profile.current-money': 'Dinheiro atual',
  'profile.accumulated-points': 'Pontos acumulados',

  /* 18.Datatable */
  'datatable.processing': 'Em processamento...',
  'datatable.zero-records': 'Nenhum resultado encontrado',
  'datatable.empty-table': 'Nenhum dado disponível nesta tabela',
  'datatable.loading': 'Carregando...',

  /* 19.Membership */
  'membership.title': 'Você deve ativar sua assinatura',
  'membership.title-mp': 'Ative sua assinatura',
  'membership.text':
    'Seu usuário está com o status <b> Pagamento pendente </b>. Para utilizar a plataforma com todos os seus benefícios, você deve pagar a assinatura.',
};

export default prMessages;
